function responseJson(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  if (response.status === 204 || response.status === 205) return;
  return response.json();
}

export default function(input, init) {
  return fetch(input, init).then(responseJson);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-fetch/src/json.js
// module id = 483
// module chunks = 0